import runOptimizeScenario from './algorithm/scenario3-5';
import runScenario1 from './algorithm/scenario1';
import runScenario2 from './algorithm/scenario2';

export default function main(values, language) {
  const s1 = runScenario1(language, values);
  const s2 = runScenario2(language, values);
  const s3 = runOptimizeScenario(language, values, 3);
  const s4 = runOptimizeScenario(language, values, 4);
  const s5 = runOptimizeScenario(language, values, 5);

  let cropMix = s1.cropMix
    .concat(s2.cropMix)
    .concat(s3.cropMix)
    .concat(s4.cropMix)
    .concat(s5.cropMix);
  let profits = s1.profits
    .concat(s2.profits)
    .concat(s3.profits)
    .concat(s4.profits)
    .concat(s5.profits);
  let waterUse = s1.waterUse
    .concat(s2.waterUse)
    .concat(s3.waterUse)
    .concat(s4.waterUse)
    .concat(s5.waterUse);
  let irrigationRequiredTime = s1.irrigationRequiredTime
    .concat(s2.irrigationRequiredTime)
    .concat(s3.irrigationRequiredTime)
    .concat(s4.irrigationRequiredTime)
    .concat(s5.irrigationRequiredTime);

  return {
    cropMix,
    profits,
    waterUse,
    irrigationRequiredTime,
  };
}
